<template>
  <div class="container">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section section-metodo">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div id="seleccionarMetodo">
        <a @click.prevent="escanearDNI">
          <div class="seleccionarMetodoOpcion">
            <figure>
              <img src="../../static/img/ingreso-camara.png" alt="Camara">
            </figure>
            <p>Escanear DNI</p>
          </div>
        </a>
        <a @click.prevent="ingresoManualTeclado">
          <div class="seleccionarMetodoOpcion seleccionarMetodoOpcionManual">
            <figure>
              <img src="../../static/img/ingreso-manual.png" alt="Manual">
            </figure>
            <p>Ingreso Manual (Veraz)</p>
          </div>
        </a>
      </div>
      <div id="seleccionarMetodoAlt">
        <a @click.prevent="ingresoManual">
          <div class="seleccionarMetodoOpcion seleccionarMetodoOpcionManual">
            <figure>
              <img src="../../static/img/ingreso-manual.png" alt="Manual">
            </figure>
            <p>Ingreso Manual</p>
          </div>
        </a>
      </div>
      <div class="bases-condiciones">
        <p>Tus datos son privados y permanecerán sólo en la base de datos de DIRECTV. Prohibida su comercialización.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
    if (!this.$store.getters['user/loggedIn']) {
      this.$router.push({ name: 'Login' });
    }
    if (!this.$store.getters['eventos/evento']) {
      this.$router.push({ name: 'SeleccionEvento' });
    }
  },
  methods: {
    escanearDNI () {
      this.$router.push({ name: 'IngresoCamara' });
    },
    ingresoManualTeclado () {
      this.$router.push({ name: 'IngresoManualTeclado' });
    },
    ingresoManual () {
      this.$router.push({ name: 'IngresoManual' });
    },
    back () {
      this.$router.go(-1);
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SeleccionMetodo.vue